import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Admin pages
import AdminLayout from './pages/admin/AdminLayout';
import LoginPage from './pages/admin/LoginPage';
import ForgotPasswordPage from './pages/admin/ForgotPasswordPage';
import ResetPasswordPage from './pages/admin/ResetPasswordPage';
import CompaniesPage from './pages/admin/CompaniesPage';
import AllUsersPage from './pages/admin/AllUsersPage';
import AllLeadsPage from './pages/admin/AllLeadsPage';
import SubscriptionPlansPage from './pages/admin/SubscriptionPlansPage';
import CancellationRequestsPage from './pages/admin/CancellationRequestsPage';
import GlobalStatsPage from './pages/admin/GlobalStatsPage';
import CompanySettingsPage from './pages/admin/CompanySettingsPage';
import UserProfilePage from './pages/admin/UserProfilePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Admin routes */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<GlobalStatsPage />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="all-users" element={<AllUsersPage />} />
              <Route path="all-leads" element={<AllLeadsPage />} />
              <Route path="subscription-plans" element={<SubscriptionPlansPage />} />
              <Route path="cancellation-requests" element={<CancellationRequestsPage />} />
              <Route path="settings" element={<CompanySettingsPage />} />
              <Route path="profile" element={<UserProfilePage />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={
              <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-gray-600">Página não encontrada</p>
                </div>
              </div>
            } />
          </Routes>

          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#22c55e',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
